import api from 'controllers/raymanAPI.js';
import React from 'react';

import {Divider} from '@material-ui/core';
import Singletons from 'controllers/Singletons.js';
import ChatMessages from './ChatMessages.js';
import ChatFooter from './ChatFooter.js';
import {makeStyles} from '@material-ui/core/styles';
import clsx from 'clsx';

const styles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      flexDirection: 'column',
      height: '100%',
      backgroundColor: theme.palette.background.default
    },
    messages: {
        flexGrow: 1,
        overflow: 'auto',
        display: 'flex',
        flexDirection: 'column',
        padding: "20px 0 20px 0"
    },
    footer: {
        flexBasis: 80,
        padding: 20,
        backgroundColor: theme.palette.background.paper
    }
  }), {name: "RaymanChat"});
  
function OperationChat({operationID, readonly, operationUserProfiles})
{
    const classes = styles();
    const userToTheRight = readonly ? operationUserProfiles.experts : Singletons.currentUser.userID;

    const [messages, setMessages] = React.useState([]);
    const [loading, setLoading] = React.useState(true);

    const addChatItem = React.useCallback((newMessage) => {
        if(newMessage.operationID !== operationID) return;
        let messagesClone = [...messages];
        messagesClone.unshift(newMessage);
        setMessages(messagesClone);
        if( !readonly && newMessage.fromUser !== Singletons.currentUser.userID ) 
        {
            Singletons.NotificationsSocket.Send('operations.chat.messages.read', 'module', {operationID: operationID, messages: [newMessage.messageID]});
        }
    },[messages, operationID, readonly]);

    const setItemRead = React.useCallback((item) => {
        if(item.operationID !== operationID || readonly) return;
        let messagesClone = [...messages];
        for(let i=messagesClone.length - 1;i>=0;i--)
        {
            if(item.messages.includes(messagesClone[i].messageID))
            {
                messagesClone[i].read = true;
            }
        }
        setMessages(messagesClone);

    },[messages, operationID, readonly]);

    const updateChatItem = React.useCallback((item) => {
        if(item.operationID !== operationID) return;
        let messagesClone = [...messages];
        for(let i=messagesClone.length - 1;i>=0;i--)
        {
            if(item.messageID === messagesClone[i].messageID)
            {
                messagesClone[i].content = item.content;
            }
        }
        setMessages(messagesClone);

    },[messages, operationID]);

    React.useEffect(() => {
        async function getChat()
        {
            setMessages([]);
            setLoading(true);
            api.operations.messages.getAll(operationID)
            .then(async (response) =>
            {
                let messages = await response.json();
                let readArray = [];
                if(!readonly)
                {
                    for(let index in messages)
                    {
                        if(!messages[index].read && messages[index].fromUser !== Singletons.currentUser.userID)
                        {
                            readArray.push(messages[index].messageID);
                        }
                    }
                    if(!readonly && readArray.length > 0) Singletons.NotificationsSocket.Send('operations.chat.messages.read', 'module', {operationID: operationID, messages: readArray});
                }
                setMessages(messages);
                setLoading(false);
            });
        }
        
        getChat();

    }, [operationID, readonly] );

    React.useEffect(() => {
        function handleNewChatItem(content, target) {
            if(!readonly && target === 'profile_administrators') return;
            addChatItem(content);
        }

        function handleUpdateChatItem(content, target) {
            if(!readonly && target === 'profile_administrators') return;
            updateChatItem(content);
        }

        function handleChatItemRead(content, target) {
            if(!readonly && target === 'profile_administrators') return;
            setItemRead(content);
        }
        
        Singletons.NotificationsSocket.on('operations.chat.messages.created', handleNewChatItem);
        Singletons.NotificationsSocket.on('operations.chat.messages.updated', handleUpdateChatItem);
        Singletons.NotificationsSocket.on('operations.chat.messages.read', handleChatItemRead);
        return () => {
            Singletons.NotificationsSocket.off('operations.chat.messages.created', handleNewChatItem);
            Singletons.NotificationsSocket.off('operations.chat.messages.updated', handleUpdateChatItem);
            Singletons.NotificationsSocket.off('operations.chat.messages.read', handleChatItemRead);
        }
    }, [addChatItem, setItemRead, updateChatItem, readonly]);
    
    return <div className={clsx(classes.root)}>
        <ChatMessages className={classes.messages} loading={loading} messages={messages} operationID={operationID} userToTheRight={userToTheRight} readonly={readonly}/>
        { readonly ? "" : 
        <>
        <Divider />
        <ChatFooter className={classes.footer} operationID={operationID} />
        </>
        }
    </div>
}

export default OperationChat;